export default [
  {
    path: '/agent/erp',
    meta: { title: '代理ERP' },
    redirect: '/agent/erp/index',
    component: () => import('@/pages/agent/layout'),
    children: [
      {
        name: 'ErpIndex',
        path: 'index',
        meta: { title: 'ERP工作台' },
        component: () =>
          import(
            /* webpackChunkName: "erp-dashboard" */ '@/pages/agent/erp/dashboard/index.vue'
          ),
      },
      {
        path: 'inventory',
        meta: { title: '库存列表' },
        component: () =>
          import(
            /* webpackChunkName: "erp-inventory" */ '@/pages/agent/erp/inventory/inventoryIndex.vue'
          ),
      },
      {
        path: 'inventory-changes',
        meta: { title: '库存变动' },
        component: () =>
          import(
            /* webpackChunkName: "erp-inventory-changes" */ '@/pages/agent/erp/inventory-changes/inventoryChangesIndex.vue'
          ),
      },
      {
        path: 'inbound',
        meta: { title: '入库单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-inbound" */ '@/pages/agent/erp/inbound/index.vue'
          ),
      },
      {
        path: 'inbound/create',
        meta: { title: '新建入库单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-inbound" */ '@/pages/agent/erp/inbound/create.vue'
          ),
      },
      {
        path: 'inbound/edit/:id?',
        meta: { title: '入库单详情' },
        component: () =>
          import(
            /* webpackChunkName: "erp-inbound" */ '@/pages/agent/erp/inbound/edit/index.vue'
          ),
      },
      {
        path: 'outbound',
        meta: { title: '出库单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-outbound" */ '@/pages/agent/erp/outbound/outboundIndex.vue'
          ),
      },
      {
        path: 'outbound/create',
        meta: { title: '新建出库单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-outbound-edit" */ '@/pages/agent/erp/outbound/edit.vue'
          ),
      },
      {
        path: 'outbound/edit/:id?',
        meta: { title: '出库单详情' },
        component: () =>
          import(
            /* webpackChunkName: "erp-outbound-edit" */ '@/pages/agent/erp/outbound/edit.vue'
          ),
      },
      {
        name: 'ErpStocktaking',
        path: 'stocktaking',
        meta: { title: '盘点单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-stocktaking" */ '@/pages/agent/erp/stocktaking/stocktakingIndex.vue'
          ),
      },
      {
        name: 'ErpStocktakingCreate',
        path: 'stocktaking/create',
        meta: { title: '新建盘点单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-stocktaking-create" */ '@/pages/agent/erp/stocktaking/edit.vue'
          ),
      },
      {
        name: 'ErpStocktakingEdit',
        path: 'stocktaking/edit/:id?',
        meta: { title: '盘点单详情' },
        component: () =>
          import(
            /* webpackChunkName: "erp-stocktaking-edit" */ '@/pages/agent/erp/stocktaking/edit.vue'
          ),
      },
      {
        name: 'InTransit',
        path: 'in-transit',
        meta: { title: '在途配送' },
        component: () =>
          import(
            /* webpackChunkName: "deliveryProcureNote" */ '../../pages/agent/deliveryProcureNote.vue'
          ),
      },
      {
        path: 'delivery-diff',
        meta: { title: '配送差异' },
        component: () =>
          import(
            /* webpackChunkName: "erp-delivery-diff" */ '@/pages/agent/erp/delivery-diff/index.vue'
          ),
      },
      {
        path: 'delivery-evidence',
        meta: { title: '举证信息' },
        component: () =>
          import(
            /* webpackChunkName: "erp-delivery-evidence" */ '@/pages/agent/erp/delivery-diff/evidence.vue'
          ),
      },
      {
        path: 'delivery-evidence-form',
        meta: { title: '举证' },
        component: () =>
          import(
            /* webpackChunkName: "erp-delivery-evidence-form" */ '@/pages/agent/erp/delivery-diff/evidence-form.vue'
          ),
      },
      {
        path: 'offline-store',
        meta: { title: '线下商城' },
        component: () =>
          import(
            /* webpackChunkName: "erp-offline-store" */ '@/pages/agent/erp/offline-store/index.vue'
          ),
      },
      {
        name: 'ErpReturns',
        path: 'returns',
        meta: { title: '退货单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-returns" */ '@/pages/agent/erp/returns/returnsIndex.vue'
          ),
      },
      {
        path: 'returns/create',
        meta: { title: '新建退货单' },
        component: () =>
          import(
            /* webpackChunkName: "erp-returns-edit" */ '@/pages/agent/erp/returns/edit.vue'
          ),
      },
      {
        path: 'returns/edit/:id?',
        meta: { title: '退货单详情' },
        component: () =>
          import(
            /* webpackChunkName: "erp-returns-edit" */ '@/pages/agent/erp/returns/edit.vue'
          ),
      },
      {
        path: 'driver-center',
        meta: { title: '司机管理中心' },
        component: () =>
          import(
            /* webpackChunkName: "erp-returns-edit" */ '@/pages/agent/erp/driver-center/index.vue'
          ),
      },
      {
        path: 'driver-form',
        meta: { title: '接受邀请' },
        component: () =>
          import(
            /* webpackChunkName: "erp-returns-edit" */ '@/pages/agent/erp/driver-form/index.vue'
          ),
      },
      {
        name: 'ErpSettings',
        path: 'settings',
        meta: { title: 'ERP工作台' },
        component: () =>
          import(
            /* webpackChunkName: "erp-dashboard" */ '@/pages/agent/erp/settings/settingsIndex.vue'
          ),
      },
    ],
  },
]
